import { render, staticRenderFns } from "./super-admin.vue?vue&type=template&id=26a42722&scoped=true"
import script from "./super-admin.vue?vue&type=script&lang=js"
export * from "./super-admin.vue?vue&type=script&lang=js"
import style0 from "./super-admin.vue?vue&type=style&index=0&id=26a42722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a42722",
  null
  
)

export default component.exports